import React from 'react';

const HeadButton = (props) => {
  function Navigate() {
    if (props.headerButtonLink.value != null) props.context.navigateTo(props.headerButtonLink.value);
    else {
      props.context.navigateTo('');
    }
  }

  var isShowHeaderButton = props.isShowHeaderButton.value;
  var designModeNumber = -1;
  var designText = 'להצטרפות';

  if (isShowHeaderButton) {
    if (props.blockButton.expandedValue[0] != null) {
      designText = (props.blockButton.expandedValue[0] as any).text.value;
      designModeNumber = (props.blockButton.expandedValue[0] as any).buttonDesignMode.value;
    }
  }

  if (!isShowHeaderButton) 
    designText = '';

  const getButtonClassByName = (designIndex) => {
    let name = '';
    switch (designIndex) {
      case 0:
        name = 'purple-button';
        break;
      case 1:
        name = 'black-button';
        break;
      case 2:
        name = 'white-button';
        break;
      case -1:
        name = 'HeadButton__button-container__button';
    }

    return name;
  };

  return (
    <>
      <div className='HeadButton'>
        <div className={` ${props.ownClass || ''} HeadButton__button-container`}>
          <a
            className={isShowHeaderButton ? `HeadButton__button-container__button ${getButtonClassByName(designModeNumber)}` : null}
            href='#'
            onClick={Navigate}>
            {designText}
          </a>
        </div>
      </div>
    </>
  );
};

export default HeadButton;
